import useUtilities from '@/views/setting/my-practice/service/UseUtilities';
const { transformPayloadForPost } = useUtilities();

export function flatPlacticeInfo(obj) {
    let newObj = {};
    Object.keys(obj).forEach(key => {
        if (key != 'contact_info') newObj[key] = obj[key]
    })
    if (obj['contact_info']) {
        Object.keys(obj['contact_info']).forEach(key => {
            newObj[key] = obj['contact_info'][key]
        })
    }
    //display primary email value if nofification email/billing email is not set
    if (!newObj['notify_email']) newObj['notify_email'] = newObj['primary_email']
    if (!newObj['billing_email']) newObj['billing_email'] = newObj['primary_email']
    // calculate if "same as office address"
    obj['shipping_address']['sameAsOffice'] = compareAddress(obj['office_address'], obj['shipping_address']);
    obj['billing_address']['sameAsOffice'] = compareAddress(obj['office_address'], obj['billing_address']);
    return newObj
}

const compareAddress = (address1, address2) => {
    if (!address1.address_line_1 || !address2.address_line_1) return false;
    const compareKeys = ['address_line_1', 'address_line_2', "city", "country", "state", "zip"]
    return !compareKeys.some(key => address1[key] != address2[key])
}

export function isObjEmpty(obj) {
    return Object.keys(obj).length === 0;
}

function checkAddress(address) {
    let fullAddress = {}
    let items = ['address_line_1', "city", "state", "zip", "country", "address_id", "address_line_2"]
    for (let item of items) {
        fullAddress[item] = address[item] ? address[item] : ""
    }
    return fullAddress
}

export function completeAddress(personInfo) {
    const addresses = ['office_address', 'shipping_address', 'billing_address']
    for (let address of addresses) {
        personInfo[address] = checkAddress(personInfo[address])
    }
    return personInfo
}

export function preparePayload(type, old_data, newObj) {
    const new_data = { ...old_data, ...newObj }
    return transformPayloadForPost(type, new_data, old_data)
}

export function sortByPriority(countryList) {
    if (!countryList) return [];
    let prioritizedCountries = [
      "United States", "Canada", "United Kingdom (Great Britain)", "Australia",
      "Germany", "France", "Netherlands", "Spain", "Italy", "Sweden", "Switzerland"
    ];
    let priorityMap = new Map(prioritizedCountries.map((country, index) => [country, index]));
    let priorityList = countryList.filter(country => priorityMap.has(country.countryName))
                                  .sort((a, b) => priorityMap.get(a.countryName) - priorityMap.get(b.countryName));
    let otherList = countryList.filter(country => !priorityMap.has(country.countryName))
                               .sort((a, b) => a.countryName.localeCompare(b.countryName));
    return [...priorityList, ...otherList];
}


